import {
  Button,
  Col,
  Form,
  Input,
  InputRef,
  Modal,
  Radio,
  RadioChangeEvent,
  Row,
  message,
} from "antd";
import { Dispatch, SetStateAction, useContext, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import Title from "../../../UI/Title/Title";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { mainActions } from "../../../../store/main/mainSlice";
import { TotalContext } from "../../MainFour";

type PropsType = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
};

const Discount = ({ open, setOpen }: PropsType) => {
  const discount = useSelector((state: any) => state.main.discount);
  const [type, setType] = useState(discount.type);
  const [amount, setAmount] = useState<number>(discount.amount);
  const { totalPrice } = useContext(TotalContext);
  const [t] = useTranslation("common");
  const onChange = (e: RadioChangeEvent) => {
    setType(e.target.value);
  };

  const dispatch = useDispatch();

  const [form] = Form.useForm();

  const valueRef = useRef<InputRef>(null);

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        valueRef.current?.focus();
      }, 0);
    }
  }, [open]);

  return (
    <Form
      layout="vertical"
      name="discount"
      form={form}
      onFinish={() => {
        if (
          (amount > totalPrice && type === "#") ||
          (amount > 100 && type === "%") ||
          amount < 0
        ) {
          message.error("Cannot add discount!");
        } else {
          dispatch(
            mainActions.addDiscount({
              amount: amount,
              type: type,
            })
          );
          setOpen(false);
        }
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          form.submit();
        }
      }}
    >
      <Modal
        maskClosable={false}
        closable={false}
        width={400}
        centered
        open={open}
        onCancel={() => setOpen(false)}
        footer={[
          <Button
            style={{
              color: "#1677FF",
              border: "1px solid #1677FF",
              height: "40px",
              width: "100px",
            }}
            onClick={() => {
              form.setFieldsValue({
                amount: discount.amount,
                type: discount.type,
              });
              setAmount(discount.amount);
              setType(discount.type);
              setOpen(false);
              document.body.classList.remove("body-scroll-lock");
            }}
          >
            {t("cancel")}
          </Button>,
          <Button
            type="primary"
            onClick={() => {
              form.submit();
              document.body.classList.remove("body-scroll-lock");
            }}
            style={{
              height: "40px",
              background: "#1677FF",
              color: "#fff",
              width: "100px",
            }}
          >
            {t("save")}
          </Button>,
        ]}
      >
        <Row gutter={[15, 0]}>
          <Col offset={1}>
            <Title title={`${t("add-discount")}`} />
          </Col>
          <Col
            offset={1}
            span={23}
            className="modaltitleEdit"
            style={{ marginBottom: "20px" }}
          >
            {t("quick-add-discount")}
          </Col>

          <Col offset={1} span={16}>
            <Form.Item name="type" label={`${t("discount")}`}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "5px",
                }}
              >
                <Radio.Group defaultValue={type} onChange={onChange}>
                  <Radio value="#">value</Radio>
                  <Radio value="%" disabled={true}>%</Radio>
                </Radio.Group>
              </div>
              <div>
                <Form.Item name="amount">
                  <Input
                    value={amount}
                    onChange={(e) => {
                      setAmount(Number(e.target.value));
                    }}
                    ref={valueRef}
                    type="number"
                    maxLength={10}
                    disabled={!discount}
                    autoComplete="off"
                    placeholder={`${t("enter-text")}`}
                  />
                </Form.Item>
              </div>
            </Form.Item>
          </Col>
        </Row>
      </Modal>
    </Form>
  );
};

export default Discount;
